<template>
  <div class="my_form">
    <el-form :model="form" ref="ruleForm" inline>
      <el-row>
        <el-col :lg="6" :md="24">
          <el-form-item label="部门:" prop="deptList" v-if="this.getUserInfo.deptName === '办公室'">
            <el-select filterable v-model="form.deptId" placeholder="请选择部门" clearable>
              <el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :md="24">
          <el-form-item label="姓名:" prop="userId" v-if="this.getUserInfo.deptName === '办公室'">
            <el-select filterable v-model="form.userId" placeholder="请选择姓名" clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="7" :md="24">
          <el-form-item label="时间:" prop="date">
            <el-date-picker :clearable="false" v-model="form.date" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :md="24" class="action" style="margin-bottom:20px">
          <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
          <!-- <el-button size="small" @click="resetForm">重置</el-button> -->          
          <download-excel
            style="margin-left:20px"
            class="export-excel-wrapper"
            :data="json_data"
            :fields="json_fields"
            type="xls"
            worksheet="My Worksheet"
            name="忘记打卡记录"
          >
            <el-button size="small" >导出</el-button>
          </download-excel>
        </el-col>
      </el-row>
    </el-form>

    <PTable :columns="columns" :loadData="loadData" ref="table">
      <template #sn='{ $index }'>
        {{ $index + 1 }}
      </template>
      <template #wjdkCount="record">
        <a class="delete" href="javascript:;" @click='handleLook(record.row.oaEmployeeDailyAttendList)'>{{ record.row.wjdkCount }}</a>
      </template>
    </PTable>
    <ItemMoudle :visible.sync='visible' :record="record" />
  </div>
</template>
      
<script>
import PTable from '@/components/PTable';
import ItemMoudle from './modules/ItemMoudle.vue';
import { Attendance } from '@/api/attendance'
import dayjs from 'dayjs'
export default {
  components: {
    PTable,
    ItemMoudle
  },
  data() {
    return {
      // 导出
      json_fields: {},
      json_data: [],
      form: {
        deptId: '',
        userId: '',
        date: [new Date(), new Date()]
      },
      columns: [
        {
          label: '基本信息',
          children: [
            {
              label: '序号',
              scopedSlots: 'sn',
              width: 100,
              fixed: "left"
            },
            {
              label: '姓名',
              prop: 'name',
              // width: 100
            },
            {
              label: '部门',
              prop: 'deptName',
              // width: 100
            }
          ]
        },
        {
          label: '打卡时间',
          children: [{
            label: '未打卡次数',
            scopedSlots: 'wjdkCount',
            // width: 100
          },
          {
            label: '上班应打卡时间',
            prop: 'date1',
            // width: 100
          },
          {
            label: '下班应打卡时间',
            prop: 'date2',
            // width: 100
          }
          ]
        }
      ],
      loadData: (pageParam) => {
        const startDate = dayjs(this.form.date[0]).format('YYYY-MM-DD')
        const endDate = dayjs(this.form.date[1]).format('YYYY-MM-DD')
        const data = {
          startDate,
          endDate,
          pageParam,
          userId: this.getUserInfo.deptName === '办公室' ?  this.form.userId : this.getUserInfo.userId,
          deptId: this.form.deptId
        }
        return Attendance.getForgotClockIn(this, data).then(res => {
          res.data.dataList.forEach(item => {
            item.date1 = '08:30'
            item.date2 = '17:00'
          })
          this.json_fields = {
            '姓名': 'name',
            '部门名称': 'deptName',
            '未打卡次数': 'wjdkCount',
          }
          res.data.dataList.forEach(item => {
            item.oaEmployeeDailyAttendList.forEach(data => {
              item[data.date + 'realDutyTime'] = data.realDutyTime
              item[data.date + 'realOffTime'] = data.realOffTime
              if (!data.realDutyTime) item[data.date + 'realDutyTime'] = data.date +  ` 08:30(${data.isCardReplace? '已补卡' : '未打卡'})`
              if (!data.realOffTime) item[data.date + 'realOffTime'] = data.date + ` 17:00(${data.isCardReplace ? '已补卡' : '未打卡'})`
              
              this.json_fields[data.date + '(上班)'] = data.date + 'realDutyTime'
              this.json_fields[data.date + '(下班)'] = data.date + 'realOffTime'
            })
          })
          this.json_data = res.data.dataList
          return res
        })
      },
      tableData: [{
        index: 1,
        date: '2016-05-03',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333
      }, {
        index: 1,
        date: '2016-05-02',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333
      }, {
        index: 1,
        date: '2016-05-04',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333
      }, {
        index: 1,
        date: '2016-05-01',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333
      }, {
        index: 1,
        date: '2016-05-08',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333
      }, {
        index: 1,
        date: '2016-05-06',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333
      }, {
        index: 1,
        date: '2016-05-07',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333
      }],
      visible: false,
      userList: [],
      deptList: [],
      record: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      Attendance.gitDict(this, { dictId: '1440944417170001920' }).then(res => {
        this.userList = res.data
      })
      Attendance.gitDict(this, { dictId: '1630757245237071872' }).then(res => {
        this.deptList = res.data
      })
    },
    submitForm() {
      if (this.$refs.table) this.$refs.table.refresh(true)
    },
    handleLook(record) {
      this.record = record.map((item, index) => {
        item.index = index + 1
        if(item.realDutyTime && item.realDutyTime.length>7) item.realDutyTime = dayjs(item.realDutyTime).format('HH:mm')
        if(item.realOffTime && item.realOffTime.length>7) item.realOffTime = dayjs(item.realOffTime).format('HH:mm')
        return item
      })
      this.visible = true
    }
  }
}
</script>
      
<style lang="scss" scoped>
.action {
  display: flex;
}
</style>
      